<template>
  <div>
    <PageTitle v-bind:title="title" v-bind:admin="false" />

    <div class="alert alert-danger" v-if="errors.load">
      {{ errors.load }}
    </div>
    <Loader v-if="loading" />
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-12 col-lg-8">
          <div class="card py-5">
            <div class="row">
              <div class="col-12 col-md-4 py-md-5 mb-3">
                <!-- <img
              style="border-radius: 10px"
              class="d-block w-50 px-2 py-5 mx-auto"
              src="/images/buddha.svg"
              alt=""
            /> -->
                <img
                  style="border-radius: 10px"
                  class="d-block w-50 mx-auto"
                  :src="data.userphoto"
                  alt=""
                />
              </div>
              <div class="col-12 col-md-8 text-center text-md-left">
                <div>
                  <router-link
                    class="heading--medium"
                    :to="{ name: 'user_show', params: { id: data.id } }"
                    >{{ data.name }}</router-link
                  >
                  &nbsp;
                  <span v-if="data.is_author" class="badge badge-success"
                    >Автор</span
                  >
                  <span v-if="data.is_admin" class="badge badge-danger"
                    >Администратор</span
                  >
                  <div class="my-3">
                    <p>
                      {{ data.fullname }}
                    </p>
                    <p>
                      <em>{{ data.description }}</em>
                    </p>
                  </div>

                  <div>
                    <img src="/images/group.svg" alt="" class="img--small" />
                    &nbsp;
                    <span>Учеников: <strong>234,566</strong></span>
                  </div>
                  <div v-if="data.is_author && data.courses">
                    <img src="/images/book.svg" alt="" class="img--small" />
                    &nbsp;
                    <span
                      >Автор курсов:
                      <strong>{{ data.courses.length }}</strong></span
                    >
                  </div>
                  <div>
                    <img src="/images/contacts.png" alt="" class="img--small" />
                    &nbsp;
                    <span>{{ data.contacts }}</span>
                  </div>

                  <div>
                    <router-link
                      class="btn btn__primary mt-3"
                      :to="{ name: 'user_profile_edit' }"
                      >Редактировать профиль</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- old version -->

      <!-- <div class="row">
          <div class="col-12 col-md-12 d-flex justify-content-center">
            <div class="card teacher-card border col-12">
              <div class="row">
                <div
                  class="col-4 overflow-hidden d-flex justify-content-center align-items-center"
                >
                  <img
                    style="border-radius: 10px"
                    class="teacher-card__img"
                    :src="data.userphoto"
                    alt=""
                  />
                </div>
                <div class="col-8 py-3 pr-3">
                  <div class="mb-2">
                    <router-link
                      class="teacher-card__name"
                      :to="{ name: 'user_show', params: { id: data.id } }"
                      >{{ data.name }}</router-link
                    >
                    &nbsp;
                    <span v-if="data.is_author" class="badge badge-success"
                      >Автор</span
                    >
                    <span v-if="data.is_admin" class="badge badge-danger"
                      >Администратор</span
                    >
                  </div>

                  <p class="teacher-card__text--secondary">
                    {{ data.fullname }}
                  </p>
                  <p class="teacher-card__text--tertiary">
                    {{ data.description }}
                  </p>
                  <div>
                    <img
                      src="/images/group.svg"
                      alt=""
                      class="teacher-card__img--secondary"
                    />
                    &nbsp;
                    <span class="teacher-card__text--quaternary"
                      >Учеников: <strong>234,566</strong></span
                    >
                  </div>
                  <div v-if="data.is_author && data.courses">
                    <img
                      src="/images/book.svg"
                      alt=""
                      class="teacher-card__img--secondary"
                    />
                    &nbsp;
                    <span class="teacher-card__text--quaternary"
                      >Автор курсов:
                      <strong>{{ data.courses.length }}</strong></span
                    >
                  </div>
                  <div>
                    <img
                      src="/images/contacts.png"
                      alt=""
                      class="teacher-card__img--secondary"
                    />
                    &nbsp;
                    <span class="teacher-card__text--quaternary">{{
                      data.contacts
                    }}</span>
                  </div>
                  <div class="mt-4">
                    <router-link
                      class="btn btn__primary"
                      :to="{ name: 'user_profile_edit' }"
                      >Редактировать профиль</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
    </div>

    <!--
		<Editor
            api-key="API_KEY"
            :init="{
                plugins: 'wordcount', 
                image_advtab: true, 
                //images_upload_url: '/upload1', 
                automatic_uploads: true, 
                file_picker_types: 'image', 
                images_upload_handler: uploadImage
            }"
            plugins = 'image link insertdatetime table emoticons'
            toolbar = 'image link insertdatetime table emoticons'
		/>
        -->
  </div>
</template>

<script>
import axios from "axios";
import Loader from "@/components/Loader";
//import Editor from '@tinymce/tinymce-vue'
import PageTitle from "@/components/PageTitle";

export default {
  name: "dashboard",
  data() {
    return {
      loading: true,
      data: [],
      errors: { load: "", uploaadfile: "" },
      show: false,
      title: "Профиль",
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get("user/dashboard");
        this.data = response.data;
        this.loading = false;
      } catch (e) {
        /*
                if (e.response.status == 520) {
                    this.errors.load = e.response.data.error
                }
                else if (e.response.status == 401) {
                    this.errors.load = e.response.data.error
                }
                else {
                    this.errors.load = 'Ошибка при загрузке данных'
                }
                */
        this.errors.load = "Ошибка при загрузке данных";
      }
    },

    /*
        uploadImage(blobInfo, success, failure) {
            this.errors.uploadfile = ''
            const config = { 'content-type': 'multipart/form-data' }
            const formData = new FormData()
            formData.append('file', blobInfo.blob(), blobInfo.filename());
            axios.post('admin/courses/7/uploadimage', formData, config)

                .then(response => {
                    console.log(response.data);
                    success(response.data.location);
                })
                .catch(error => {
                    failure('HTTP Error.'+error.response.data.errors.file[0]);
                    if (error.response.status == 520) {
                        this.errors.uploadfile = error.response.data.error
                    }
                    else {
                        this.errors.uploadfile = 'Неизвестная ошибка при загрузке файла.'
                    }
                })
        },
        */
  },
  components: {
    Loader,
    PageTitle,
    //Editor,
  },
};
</script>

<!-- <style lang="scss" scoped> -->
<style scoped>




/* 
    Dashboard
*/


.img--small {
    display: inline;
    width  : 15px;
    height : 20px;
}





/*
    teacher card
*/
/*
// .teacher-card {
//   padding: 10px 20px;
//   margin-bottom: 20px;
// }

// .teacher-card__img {
//   width: 200px;
//   height: 200px;
//   object-fit: cover;
//   border-radius: 50%;
// }

// .teacher-card__name {
//   font-size: 1.2rem;
// }

// [class*="teacher-card__text"] {
//   margin-bottom: 0.3rem;
// }

// .teacher-card__text--secondary {
//   font-size: 1rem;
// }

// .teacher-card__text--tertiary {
//   font-size: 0.75rem;
//   // color: coral;
//   color: blue;
// }

// .teacher-card__img--secondary {
//   display: inline;
//   width: 15px;
//   height: 20px;
// }

// .teacher-card__text--quaternary {
//   font-size: 0.75rem;
// }
*/
</style>